import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, CheckCircle2 } from 'lucide-react';
const names = ['María', 'Juan', 'Carlos', 'Ana', 'Luis', 'Laura', 'Diego', 'Sofía', 'Valentina', 'Mateo', 'Camila', 'Martín'];
const cities = ['Buenos Aires', 'Santiago', 'Bogotá', 'Lima', 'Ciudad de México', 'Montevideo', 'Córdoba', 'Medellín', 'Guadalajara', 'Rosario', 'Quito'];
export const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setCurrentData({
        name: randomName,
        city: randomCity,
        time: `Hace ${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimer = setTimeout(showPopup, 3000);
    const interval = setInterval(() => {
      showPopup();
    }, Math.floor(Math.random() * 10000) + 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-149" data-mp="1az1zjswyrirg">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      type: 'spring',
      bounce: 0.4
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-xl shadow-2xl border border-gray-100 p-4 max-w-sm flex items-start gap-4" data-id="element-150" data-mp="n6bpjp8mf9jt">
          <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-151" data-mp="28j544vyhow8t">
            <CheckCircle2 className="text-green-600" size={24} data-id="element-152" data-mp="23lwjmopvcg4e" />
          </div>
          <div data-id="element-153" data-mp="2aol3ubat2827">
            <p className="text-sm text-gray-800" data-id="element-154" data-mp="2ap30h91dqoan">
              <span className="font-bold" data-id="element-155" data-mp="2aobbih2afotc">{currentData.name}</span> acaba de
              comprar el libro digital.
            </p>
            <div className="flex items-center gap-1 mt-1 text-xs text-gray-500" data-id="element-156" data-mp="2kn0lzoruu6zk">
              <MapPin size={12} data-id="element-157" data-mp="2kkwmdj0znu53" />
              <span data-id="element-158" data-mp="2pmdh0wsvqkd8">Desde {currentData.city}</span>
              <span className="mx-1" data-id="element-159" data-mp="2pjrdd8940p0a">•</span>
              <span data-id="element-160" data-mp="1rylju2ttnj5n">{currentData.time}</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};